import React from 'react'
import PropTypes from 'prop-types'
import { ButtonGroup } from 'reactstrap'
import { connect } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import {
  hideContract,
  showContract,
  setUniqueContractVisible,
  removeContracts,
} from 'actions/contractSelection'

import {
  callValorisation
} from 'actions/contract'

import { isAdmin } from 'selectors/user'

const CurrentSelectionItem = (props) => {
  const { contract, visibleContracts, hideContract, showContract, valoriseContract } = props
  const { t } = useTranslation()
  const callValoriseContract = React.useCallback(() => {
    valoriseContract(t('sidebar.current.valoriseContract'))
  })

  const location = useLocation()
  const history = useHistory()

  const { CtrNrjId, id, FormattedName } = contract
  const isSelectionItemVisible = visibleContracts.includes(id)

  const isZoomOnContract = props.selectedContract && props.selectedContract.id === id

  const isOnExec = isZoomOnContract && location.pathname.startsWith('/exec')

  const isOnTransactions = isZoomOnContract && location.pathname.startsWith('/transactions')
  const isOnStratRW = isZoomOnContract && location.pathname.startsWith('/admin')

  return (
    <li
      className={
        'd-flex selected-contract' +
        (isSelectionItemVisible ? ' visible' : '') +
        (isZoomOnContract ? ' zoom' : '')
      }
    >
      {CtrNrjId === 2 && <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#00aaff"><path d="m422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z" /></svg>
      }
      {CtrNrjId === 1 && <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#008480"><path d="M240-400q0 52 21 98.5t60 81.5q-1-5-1-9v-9q0-32 12-60t35-51l113-111 113 111q23 23 35 51t12 60v9q0 4-1 9 39-35 60-81.5t21-98.5q0-50-18.5-94.5T648-574q-20 13-42 19.5t-45 6.5q-62 0-107.5-41T401-690q-39 33-69 68.5t-50.5 72Q261-513 250.5-475T240-400Zm240 52-57 56q-11 11-17 25t-6 29q0 32 23.5 55t56.5 23q33 0 56.5-23t23.5-55q0-16-6-29.5T537-292l-57-56Zm0-492v132q0 34 23.5 57t57.5 23q18 0 33.5-7.5T622-658l18-22q74 42 117 117t43 163q0 134-93 227T480-80q-134 0-227-93t-93-227q0-129 86.5-245T480-840Z" /></svg>}
      <span className="w-90" style={{ marginRight: 8, color: 'black' }}>
        {FormattedName}
      </span>
      <ButtonGroup className="ml-auto">
        {props.isAdmin && (
          <div className={'btn btn-secondary' + (isZoomOnContract ? ' zoom' : '')}>
            <i
              onClick={() => {
                props.setUniqueContractVisible(true)
                history.push(`/transactions/${contract.id}`)
              }}
              className={'icon-collapse-plus' + (isOnTransactions ? ' selected-activity' : '')}
            />
          </div>
        )}

        {props.isAdmin && (
          <div className={'btn btn-secondary' + (isZoomOnContract ? ' zoom' : '')}>
            <i
              onClick={() => {
                props.setUniqueContractVisible(false)
                history.push('/admin/')
              }}
              className={'icon-ico-menu-parameters' + (isOnStratRW ? ' selected-activity' : '')}
            />
          </div>
        )}

        <div className={'btn btn-secondary' + (isZoomOnContract ? ' zoom' : '')}>
          <i
            onClick={() => {
              if (isOnExec && isZoomOnContract) {
                props.removeUniqueContractVisible()
              } else {
                props.setUniqueContractVisible(true)
                history.push('/exec')
              }
            }}
            className={'icon-diag' + (isOnExec ? ' selected-activity' : '')}
          />
        </div>
        <div
          onClick={props.removeContract}
          className={'btn btn-secondary' + (isZoomOnContract ? ' zoom' : '')}
        >
          <i className="icon-cross" />
        </div>
        {props.isAdmin && (
          <div onClick={callValoriseContract} className="btn btn-secondary">
            <i className="icon-ico-brdcrmb-plain" />
          </div>
        )}

      </ButtonGroup>
    </li>
  )
}

const mapStateToProps = (state) => ({
  visibleContracts: state.contracts.visibleContracts,
  selectedContract: state.contracts.zoomOnContract,
  isAdmin: isAdmin(state),
})

const mapDispatchToProps = (dispatch, { contract }) => ({
  showContract: () => {
    dispatch(showContract(contract.id))
  },
  hideContract: () => {
    dispatch(hideContract(contract.id))
  },
  setUniqueContractVisible: (readonly) => {
    dispatch(setUniqueContractVisible(contract, readonly))
  },
  removeUniqueContractVisible: () => {
    dispatch(setUniqueContractVisible(null))
  },
  removeContract: () => {
    dispatch(removeContracts([contract.id]))
  },
  valoriseContract: (message) => {
    dispatch(callValorisation([contract.id], message))
  }
})

CurrentSelectionItem.propTypes = {
  contract: PropTypes.object.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(CurrentSelectionItem)
